import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "./Navigation.js";
import { getTokenInternal } from "./useToken";

export default function AllListedItems() {
  const [allAccounts, setAllAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [token, setToken] = useState();

  const navigate = useNavigate();

  const fetchData = async () => {
    const token = await getTokenInternal();
    setToken(token);
    if (
      !token ||
      (token.account.role !== "management" && token.account.role !== "owner")
    ) {
      navigate("/");
      return;
    }

    const url = `${process.env.REACT_APP_API_HOST}/api/accounts`;
    const response = await fetch(url);
    const completeList = await response.json();
    setAllAccounts(completeList);
    setFilteredAccounts(completeList);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const filtered = allAccounts.filter((account) =>
      account.username.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredAccounts(filtered);
  }, [searchTerm, allAccounts]);

  const handleEditAccount = (account) => {
    navigate(`/edit-account/${account.id}`, {
      state: { account },
    });
  };

  const handleDeleteAccount = async (account) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}/api/accounts/${account.username}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const updatedAccounts = allAccounts.filter(
          (acc) => acc.id !== account.id
        );
        setFilteredAccounts(updatedAccounts);
      } else {
        console.error("Failed to delete account:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting account:", error);
    }
  };

  return (
    <div>
      <Nav />
      <div className="mb-4">
        <label
          htmlFor="search"
          className="block text-sm font-medium text-gray-700"
        >
          Search:
        </label>
        <input
          type="text"
          id="search"
          className="mt-1 p-2 border rounded-md w-full"
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Account count */}
      <div className="mb-4">
        <strong>Total Accounts: {filteredAccounts.length}</strong>
      </div>

      <table className="min-w-full divide-y divide-gray-200 text-white text-left">
        <thead>
          <tr>
            <th>ID</th>
            <th>Account Name</th>
            <th>Discord Name</th>
            <th>Role</th>
            <th>Visible</th>
            <th>Question</th>
            <th>Answer</th>
            <th>Actions</th>
            <th>Total: {filteredAccounts.length}</th> {/* New column for account count */}
          </tr>
        </thead>
        <tbody>
          {filteredAccounts.map((account) => (
            <tr key={account.id}>
              <td>{account.id}</td>
              <td>{account.username}</td>
              <td>{account.discord_name}</td>
              <td>{account.role}</td>
              <td>{account.visible.toString()}</td>
              <td>{account.question}</td>
              <td>{account.answer}</td>
              <td>
                <button
                  className="mr-2 p-1 border rounded"
                  onClick={() => handleEditAccount(account)}
                  disabled={
                    token &&
                    token.account.role !== "owner" &&
                    account.role === "owner"
                  }
                >
                  Edit
                </button>
              </td>
              <td>
                <button
                  type="button"
                  className="ml-2 bg-red-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
                  onClick={() => handleDeleteAccount(account)}
                  disabled={
                    token &&
                    token.account.role !== "owner" &&
                    account.role === "owner"
                  }
                >
                  Delete Account
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}


// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Nav from "./Navigation.js";
// import { getTokenInternal } from "./useToken";

// export default function AllListedItems() {
//   const [allAccounts, setAllAccounts] = useState([]);
//   const [filteredAccounts, setFilteredAccounts] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [token, setToken] = useState();

//   const navigate = useNavigate();


//   const fetchData = async () => {
//     const token = await getTokenInternal();
//     setToken(token);
//     if (
//       !token ||
//       (token.account.role !== "management" && token.account.role !== "owner")
//     ) {
//       navigate("/");
//       return;
//     }

//     const url = `${process.env.REACT_APP_API_HOST}/api/accounts`;
//     const response = await fetch(url);
//     const completeList = await response.json();
//     setAllAccounts(completeList);
//     setFilteredAccounts(completeList);
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     const filtered = allAccounts.filter((account) =>
//       account.username.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredAccounts(filtered);
//   }, [searchTerm, allAccounts]);

// const handleEditAccount = (account) => {

//   navigate(`/edit-account/${account.id}`, {
//     state: { account },
//   });
// };


// const handleDeleteAccount = async (account) => {
//   try {
//     const url = `${process.env.REACT_APP_API_HOST}/api/accounts/${account.username}`;
//     const response = await fetch(url, {
//       method: "DELETE",
//       headers: {
//         Authorization: `Bearer ${token?.access_token}`,
//         "Content-Type": "application/json",
//       },
//     });

//     if (response.ok) {
//       const updatedAccounts = allAccounts.filter(
//         (acc) => acc.id !== account.id
//       );
//       setFilteredAccounts(updatedAccounts);
//     } else {
//       console.error("Failed to delete account:", response.statusText);
//     }
//   } catch (error) {
//     console.error("Error deleting account:", error);
//   }
// };

//   return (
//     <div>
//       <Nav />
//       <div className="mb-4">
//         <label
//           htmlFor="search"
//           className="block text-sm font-medium text-gray-700"
//         >
//           Search:
//         </label>
//         <input
//           type="text"
//           id="search"
//           className="mt-1 p-2 border rounded-md w-full"
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>
//       <table className="min-w-full divide-y divide-gray-200 text-white text-left">
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Account Name</th>
//             <th>Discord Name</th>
//             <th>Role</th>
//             <th>Visible</th>
//             <th>Question</th>
//             <th>Answer</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredAccounts.map((account) => (
//             <tr key={account.id}>
//               <td>{account.id}</td>
//               <td>{account.username}</td>
//               <td>{account.discord_name}</td>
//               <td>{account.role}</td>
//               <td>{account.visible.toString()}</td>
//               <td>{account.question}</td>
//               <td>{account.answer}</td>
//               <td>
//                 <button
//                   className="mr-2 p-1 border rounded"
//                   onClick={() => handleEditAccount(account)}
//                   disabled={
//                     token &&
//                     token.account.role !== "owner" &&
//                     account.role === "owner"
//                   }
//                 >
//                   Edit
//                 </button>
//               </td>
//               <td>
//                 <button
//                   type="button"
//                   className="ml-2 bg-red-500 border-solid border-2 border-white text-white px-1 py-0 rounded"
//                   onClick={() => handleDeleteAccount(account)}
//                   disabled={
//                     token &&
//                     token.account.role !== "owner" &&
//                     account.role === "owner"
//                   }
//                 >
//                   Delete Account
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }
